import {useQuery, gql} from "@apollo/client";
var ABOUT_US = gql`
query AboutUs($contentItemId: ID) {
  aboutUs(where: {contentItemId: $contentItemId, localization: {culture_starts_with: "fa"}}) {
contentItemId
    path
    htmlBody {
      html
    }
    displayText
    hasColumnizedStructure
    licenceAndImage {
      contentItems {
        ... on LicencesImageAndText {
          displayText
          modifiedUtc
          htmlBody {
            html
          }
          licenceImage {
            urls(first: 1)
          }
        }
      }
    }
    aboutUsChart {
      contentItems {
        ... on AboutUsChart {
          displayText
          bag {
            contentItems {
              ... on AboutUsData {
                displayText
                xPoint
                yPoint
              }
            }
          }
        }
        ... on OrganizationNode {
          id
          name
          children {
            contentItems {
              ... on OrganizationNode {
                id
                name
                color
                displayText
                image {
                  urls(first: 1)
                }
                offset
                level
                parentId
                children {
                  contentItems {
                    ... on OrganizationNode {
                      id
                      name
                      displayText
                      color
                      image {
                        urls(first: 1)
                      }
                      level
                      offset
                      parentId
                    }
                  }
                }
              }
            }
          }
          displayText
          offset
          color
          level
          image {
            urls(first: 1)
          }
          parentId
        }        
      }
    }
  }
  aboutUsPageHeader {
    aboutUsPageHeaderImage {
      urls(first: 1)
    }
  }
}

`;
export const useAboutUs = (contentItemId) => {
  const {error, data, loading} = useQuery(ABOUT_US, {
    variables: { contentItemId: contentItemId }
  });
  return {
    error,
    data,
    loading
  }
}